import { StaticBaseDao } from '@/dao';
import { IntArray, IBUDataEvent, PostResponse, IBUDataCategory, IBUSportsEvent, IBUSportRace } from '@/objects/generated';

export class IBUDao extends StaticBaseDao {
    public static async FetchEvent(EventID: number, uids: IntArray, detailed: boolean): Promise<IBUDataEvent[]> {
        return this.BaseFetchArray(
            IBUDataEvent,
            `IBU/FetchEvent` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (detailed == undefined ? '' : `detailed=${detailed}`),
            'POST',
            uids,
        );
    }
    public static async SaveEvent(EventID: number, baseObjects: IBUDataEvent[]): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `IBU/SaveEvent` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            baseObjects,
        );
    }
    public static async FetchCategories(EventID: number, uids: number[], detailed: boolean): Promise<IBUDataCategory[]> {
        return this.BaseFetchArray(
            IBUDataCategory,
            `IBU/FetchCategories` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (uids == undefined ? '' : `${this.makeGetStringFromList(uids, 'uids')}`) +
                '&' +
                (detailed == undefined ? '' : `detailed=${detailed}`),
            'GET',
        );
    }
    public static async SaveCategories(EventID: number, baseObjects: IBUDataCategory[]): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `IBU/SaveCategories` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            baseObjects,
        );
    }
    public static async LoadEventsFromIBU(): Promise<IBUSportsEvent[]> {
        return this.BaseFetchArray(IBUSportsEvent, `IBU/LoadEventsFromIBU`, 'POST');
    }
    public static async LoadEventFromIBU(ibuEventID: string | null): Promise<IBUSportRace[]> {
        return this.BaseFetchArray(
            IBUSportRace,
            `IBU/LoadEventFromIBU` + '?' + (ibuEventID == undefined ? '' : `ibuEventID=${ibuEventID}`),
            'POST',
        );
    }
}
